import { render, staticRenderFns } from "./asks-all.vue?vue&type=template&id=4b3e4532&"
import script from "./asks-all.vue?vue&type=script&lang=js&"
export * from "./asks-all.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports